































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { CardWidgetTab } from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { openUrl } from "@/shared/urlHelper";

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class NoHsaStoreWidget extends Vue {
  custodianStore = useCustodianSettingsStore();
  portalCustomizationStore = usePortalCustomizationStore();

  @Prop()
  width: number;

  @Prop()
  height: number;

  get activeTabs (): CardWidgetTab[] {
    return [{ title: "Check Eligibility", disabled: false, visible: true }];
  }

  async openShop () {
    await this.custodianStore.logHsaStoreWidgetClick(true);
  }

  async openEligibility (event) {
    openUrl(event.currentTarget.href);
    await this.custodianStore.logHsaStoreWidgetClick(false);
  }

  @Watch("portalCustomizationStore.partnerId")
  refreshPartner () {
    this.portalCustomizationStore.getHsaStoreInfo(this.portalCustomizationStore.partnerId);
  }

  mounted (): void {
    this.portalCustomizationStore.getHsaStoreInfo(this.portalCustomizationStore.partnerId);
  }
}
